import release from './release';
import releaseAction from './release-action';
import settings from './settings';

export const controllers = {
  release,
  'release-action': releaseAction,
  settings,
};
